import { isMobile } from 'react-device-detect';

import { ModalRoot, Modal, ModalHeader, ModalContent, Button, Icon } from '@pella/sash-framework';

import { HOLD_REASONS } from '../../../data/constants';

import * as classes from './ActionModal.module.css';

/**
 * On Hold Reason modal molecule.
 * Presents the configured hold reasons as a stacked list of buttons. Selecting a
 * reason invokes `onSelectReason` with the reason label; the close ("X") button
 * dismisses the modal without selecting a reason.
 * @param {Local.ActionModalProps} props - Component props
 */
export const ActionModal = ({ open, close, onSelectReason }) => (
  <ModalRoot open={open}>
    <Modal
      data-testid='on-hold-reason-modal'
      effect='scale-up'
      showClose={false}
      fullScreen={isMobile}
      className={classes.modal}
    >
      <ModalHeader className={classes.header}>
        <span className={classes.title}>On Hold Reason</span>
        <button type='button' className={classes.close} aria-label='Close' onClick={close}>
          <Icon name='close' />
        </button>
      </ModalHeader>
      <ModalContent>
        <div className={classes.reasons}>
          {Object.values(HOLD_REASONS).map((reason) => (
            <Button
              key={reason}
              color='secondary'
              className={classes.reasonButton}
              onClick={() => onSelectReason(reason)}
            >
              {reason}
            </Button>
          ))}
        </div>
      </ModalContent>
    </Modal>
  </ModalRoot>
);
